import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Login2Fa from '../views/Login2Fa.vue'
import EmailConfirmation from '../views/EmailConfirmation.vue'
import ResetPassword from '../views/ResetPassword.vue'

import Notifications from '../views/Notifications.vue'
import NotFound from '../views/NotFound.vue'
import Roles from '../views/settings/roles/Roles.vue'

import CreateRole from '../views/settings/roles/CreateRole.vue'
import UpdateRole from '../views/settings/roles/UpdateRole.vue'
import Users from '../views/settings/users/Users.vue'
import System from '../views/settings/system/System.vue'
import Configurations from '../views/settings/system/Configurations.vue'
import CreateUser from '../views/settings/users/CreateUser.vue'
import UpdateUser from '../views/settings/users/UpdateUser.vue'

import Layout from '../Layout.vue'
import Logs from '../views/logs/Manage.vue'

import PageNoPermission from '../views/PageNoPermission.vue';
import Events from '../views/Events.vue'
import EventsCreate from '../views/EventsCreate.vue'
import EventView from '../views/EventView.vue'
import MatchCalendarsPro from '../views/MatchCalendarsPro.vue'
import PoliticaDePrivacidade from '../views/PoliticaDePrivacidade.vue'
import Contacto from '../views/Contacto.vue'
import HashRedirect from '../views/HashRedirect.vue';
import Register from '../views/Register.vue'
import SuperAdmin from '../views/SuperAdmin.vue';
import PageEventClosed from '../views/PageEventClosed.vue'

import PoliticaPrivacidade from '@/views/PoliticaDePrivacidade.vue'
import TermosECondicoes from '../views/TermosECondicoes.vue'
import EventIsClosed from '@/views/EventIsClosed.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '',
                redirect: 'home'
            },
            {
                path: 'event-is-closed/:id',
                component: EventIsClosed,
                meta: {requiresAuth: true}
            },
            {
                path: 'home',
                name: 'Events',
                component: Events,
                meta: { requiresAuth: true }
            },
            {
                path: 'notifications',
                component: Notifications,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/roles',
                component: Roles,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/roles/create',
                component: CreateRole,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/roles/:id',
                component: UpdateRole,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/users',
                component: Users,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/system',
                component: System,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/system-configurations',
                component: Configurations,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/my-user/:id',
                component: UpdateUser,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/logs',
                component: Logs,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/users/create',
                component: CreateUser,
                meta: { requiresAuth: true }
            },
            {
                path: 'settings/users/:id',
                component: UpdateUser,
                meta: { requiresAuth: true }
            },
            {
                path: '/create-event',
                name: 'EventsCreate',
                component: EventsCreate,
                meta: { requiresAuth: true }
            },
            {
                path: '/event-view/:id',
                name: 'EventView',
                component: EventView,

            },
            {
                path: "/event-edit/:id",
                name: "EventEdit",
                component: EventsCreate,
            },
            {
                path: '/termos_condicoes',
                name: 'TermosECondicoes',
                component: TermosECondicoes,
            },
            {
                path: '/politica_privacidade',
                name: 'PoliticaDePrivacidade',
                component: PoliticaDePrivacidade,
            },
            {
                path: '/match_calendars_pro',
                name: 'MatchCalendarsPro',
                component: MatchCalendarsPro,

            },
            {
                path: '/contacto',
                name: 'Contacto',
                component: Contacto,

            },
            {
                path: '/event/hs/:hash',
                name: 'HashRedirect',
                component: HashRedirect
            },
            {
                path: '/users',
                name: 'SuperAdmin',
                component: SuperAdmin,
                meta: { requiresAuth: true, requiresSuperAdmin: true }
            },
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/register',
        name: 'Register',
        component: Register
    },
    {
        path: '/2fa',
        component: Login2Fa
    },
    {
        path: '/verify-email/:id/:hash',
        component: EmailConfirmation
    },
    {
        path: '/reset/:id/:hash',
        component: ResetPassword
    },
    {
        path: '/no-permission',
        name: 'NoPerm',
        component: PageNoPermission
    },
    {
        path: '/no-event',
        name: 'NoEvent',
        component: PageEventClosed
    },
    {
        path: '/politica-privacidade',
        component: PoliticaPrivacidade
    },
    { path: '*', component: NotFound }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = localStorage.getItem('auth') === '1'; // Verifique se o usuário está autenticado
    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        // Store the current Path so router knows where to send user after login
        localStorage.setItem("redirectPath", to.fullPath);
        next({ name: 'Login' }); // Redirecione para a página de login se não estiver autenticado
        return;
    } else {
        next(); // Continue para a rota desejada
    }
})

export default router